import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Yes, I know there is another ellipsis component. It's a mess and this one is a fraction of the size
// and works pretty gracefully. Note that it doesn't specify a size for the text. That is driven by its
// container.
//
// An example is in the attachments-block where the parent component is flex and has a width and the
// ellipsis-text is set at max-width: 100%.
@customElement('ellipsis-text')
export class EllipsisText extends LitElement {
  @property({ type: String })
  _title = '';

  static override styles = css`
    :host {
      display: inline-block;
    }

    div {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  `;

  override render() {
    return html`<div title="${this._title}">
      <slot></slot>
    </div>`;
  }

  override firstUpdated() {
    this._title = this.innerText;
  }
}
